import React from "react";
import { useIsRtl } from "../../utils/LayoutContext";
import AnchorButton from "../AnchorButton/AnchorButton";
import styles from "./HomePageCreateAiBlock.module.scss";
import GetText, { useString } from "../../i18n/GetText";
import { SanityImage, SanityInternalLink } from "../../model/common";
import microbitWithSparkles from "./microbit-with-sparkles-icon.svg";
import Text from "../Text/Text";
import { Col, Row, Wrapper } from "../Grid";
import { useLanguage } from "../../i18n/LanguageContext";

const supportedAiLandingPageLanguages = [
  "ca",
  "es-es",
  "ja",
  "ko",
  "nl",
  "pl",
  "pt-br",
  "zh-tw"
];

interface HomePageCreateAiBlockProps {
  desktopImage: SanityImage;
  mobileImage: SanityImage;
  callToAction: SanityInternalLink;
  callToActionText: string;
}

// eslint-disable-next-line no-empty-pattern
const HomePageCreateAiBlock = ({}: HomePageCreateAiBlockProps) => {
  const language = useLanguage();
  const isRtl = useIsRtl();
  const blockImageAlt = useString(
    "block-img-alt",
    "Illustration of micro:bit CreateAI themes: clapping hands, graph lines, a MakeCode AI code block that shows a heart icon. The code block is being transferred to a micro:bit which also shows the heart. In white on a green background. Graph lines are blue and red and the micro:bit's LEDs are red."
  );
  const microbitWithSparklesAlt = useString(
    "microbit-with-sparkles-img-alt",
    "Smiley face micro:bit emoji with AI sparkles"
  );
  return (
    <>
      <div className={styles.root} dir="ltr">
        <Wrapper className={styles.wrapperPadding}>
          <Row className={styles.topRow}>
            <Col md={5} sm={12}>
              <div className={styles.content} dir={isRtl ? "rtl" : "ltr"}>
                <h1 className={styles.visuallyHidden}>BBC micro:bit</h1>
                <Text variant="h1" as="p">
                  micro:bit CreateAI
                </Text>
                <p className={styles.tagline}>
                  <GetText
                    id="tagline"
                    fallback="Try our new machine learning tool"
                  />
                </p>
                <img
                  src={microbitWithSparkles}
                  style={{
                    aspectRatio: "150.30263 / 88.794741",
                    marginTop: 10
                  }}
                  width="400px"
                  alt={microbitWithSparklesAlt}
                />
                <AnchorButton
                  primary={true}
                  to={`${
                    supportedAiLandingPageLanguages.includes(
                      language.toLowerCase()
                    )
                      ? `/${language.toLowerCase()}`
                      : ""
                  }/ai/`}
                >
                  <GetText id="find-out-more" fallback="Find out more" />
                </AnchorButton>
              </div>
            </Col>
            <Col className={styles.desktopImageCol} md={7}>
              <img
                height="532"
                src="https://cdn.sanity.io/images/ajwvhvgo/production/d64f05a42223e0fc5cfb1196daecfc2326600619-4497x2777.png"
                alt={blockImageAlt}
              />
            </Col>
          </Row>
          <Row className={styles.mobileImageRow}>
            <Col className={styles.noPadding}>
              <img
                width="991"
                src="https://cdn.sanity.io/images/ajwvhvgo/production/b8f819031f40f65b9ca351ee9c923acaf0eac88a-1921x1447.png"
                alt={blockImageAlt}
              />
            </Col>
          </Row>
        </Wrapper>
      </div>
    </>
  );
};
export default HomePageCreateAiBlock;
